export default __webpack_public_path__ + "static/media/BackArrow.13bea330.svg";